export function getDynamicColumns<T>(
    item: T,
    filterItems: string[] = []
): string[] {
    const _filterItems =
        filterItems && filterItems.length > 0 ? filterItems : [];
    const keys = Object.keys(item);
    let result = keys;
    result = result.filter(x => !_filterItems.includes(x));
    result = result.filter(x => !!item[x]);
    result = result.filter(x => !(item[x] instanceof Date));
    result = result.filter(
        x => typeof item[x] === 'object'
        // || typeof item[x] === 'string'
        // || typeof item[x] === 'boolean'
        // || typeof item[x] === 'number'
    );
    return result;
}
